import {IconicHelpers} from './helpers.js';

/**
 * Megamenu.
 */
class IconicMegamenu {
	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		'megamenus': '.iconic-megamenu',
		'toggles': '.iconic-megamenu__navigation-toggle',
		'sections': '.iconic-megamenu__content-section',
	};

	/**
	 * Run panels.
	 */
	constructor() {
		this.watch();
	};

	/**
	 * Watch for events.
	 */
	watch = () => {
		document.querySelectorAll( this.classes.toggles ).forEach( ( toggle ) => {
			toggle.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.toggleSection( toggle );
			} );
		} );
	};

	/**
	 * Toggle section.
	 *
	 * @param toggle
	 */
	toggleSection = ( toggle ) => {
		let activeToggleClass = IconicHelpers.getUsableClassName( this.classes.toggles, '--active' ),
			activeSectionClass = IconicHelpers.getUsableClassName( this.classes.sections, '--active' ),
			megamenuParent = toggle.closest( this.classes.megamenus ),
			toggles = megamenuParent.querySelectorAll( this.classes.toggles ),
			sections = megamenuParent.querySelectorAll( this.classes.sections ),
			toggleIndex = [ ...toggles ].indexOf( toggle );

		// Remove active states.
		sections.forEach( node => {
			node.classList.remove( activeSectionClass );
		} );

		// Remove active states.
		toggles.forEach( node => {
			node.classList.remove( activeToggleClass );
		} );

		// Add active states.
		toggle.classList.add( activeToggleClass );
		[ ...sections ][ toggleIndex ].classList.add( activeSectionClass );
	};
}

export {IconicMegamenu};